import React from "react";
import PropTypes from "prop-types";

import { IPackage } from "../interfaces/IPackage";
import { ButtonLink, Button } from "../components/button";

import { getPackageStatus } from "../utils/packageUtils";
import { packages } from '../config/statusConfig'

function CPackageCard(props) {
  const { onShowPackageClick, onDeletePackageClick } = props;
  const item: IPackage = props.element;
  let packagePercent = 0;
  let shippingDateLabel;
  let actionButtons;

  if (item.count_articles > 0) {
    packagePercent = (item.count_articles_received / item.count_articles) * 100;
  }

  if (item.shipping_date && !item.delivery_date) {
    shippingDateLabel = (
      <p className="text-muted">
        Fecha estimada de envio: <mark>{item.shipping_date}</mark>
      </p>
    );
  }
  if (item.delivery_date) {
    shippingDateLabel = (
      <p className="text-muted">
        Completado el: <mark>{item.delivery_date}</mark>
      </p>
    );
  }

  if (item.status !== packages.archived) {
    const canDeletePackage = [packages.empty, packages.completing].includes(
      item.status
    )
    actionButtons = (
      <div className="">
        <ButtonLink
          href={`editar?id=${item.id}`}
          icon='icon-edit-2'
          extraClass="btn-link"
        />
        {canDeletePackage && (
          <Button
            icon='icon-trash-2'
            extraClass="btn-link"
            onClick={() => {
              onDeletePackageClick(item.id)
            }}
          />
        )}

      </div>
    );
  }

  return (
    <div className="card hoverable">
      <div className="card-header">
        <div className="flex-2-separated">
          <h5 className="card-title mb-0">
            <span>{item.name}</span>
          </h5>

          {getPackageStatus(item.status)}
        </div>
      </div>
      <div className="card-body">
        <p>
          {item.count_articles_received} / {item.count_articles} Articulos{" "}
          <span className="float-right">{packagePercent}%</span>
        </p>
        <div
          className="progress mb-4"
          style={{
            height: "4px",
          }}
        >
          <div
            className="progress-bar bg-success"
            role="progressbar"
            style={{
              width: `${packagePercent}%`,
            }}
          ></div>
        </div>

        {shippingDateLabel}
      </div>
      <div className="card-footer">
        <div className="flex-2-separated">
          {actionButtons}
          <button
            className="btn btn-link"
            onClick={() => {
              onShowPackageClick(item.id);
            }}
          >
            Observar
          </button>
        </div>
      </div>
    </div>
  );
}
CPackageCard.propTypes = {
  element: PropTypes.object.isRequired,
  onShowPackageClick: PropTypes.func.isRequired,
  onDeletePackageClick: PropTypes.func.isRequired
};

export default CPackageCard;
